import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchGatewayInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Bird · Worm's Eye View";

const callBirdWormsEyeView = async (
	messageId: string,
	jwt: string,
	view: string,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				inputs: {
					$img: imageBase64,
					$view: view,
				},
				tool_document_id,
				jwt,
			};
			return fetchBirdWormsEyeView(data, executionContext, messageId);
		},
	});
	return success;
};

export async function fetchBirdWormsEyeView(
	params: {
		inputs: {
			$img: string;
			$view: string;
		};
		tool_document_id: string;
		jwt: string;
	},
	executionContext: any,
	messageId: string,
): Promise<string | false> {
	return fetchGatewayInferenceJob(params, executionContext, messageId);
}

export function useListenBirdWormsEyeViewMessage() {
	useListenFromRenderer([
		{
			key: "birdWormsEyeView",
			onMessage: async (message) => {
				const success = await callBirdWormsEyeView(
					message.id,
					message.values.jwt,
					message.values.view,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
